module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/02ba94a0effe2277def1038341d652d7.png";